import { getDayOfWeekFromDate } from "../GlobalFunctions";
import { getApprovalState } from "../Mappings";

export const LinehaulFloatingDataReducer = (state, action) => {
  console.log(action);
  const { truckId, week, day, itemId, startDate, items, itemData, roleId, ...others } = action;
  switch (action.type) {
    case "INSERT_NEW_ITEMS":
      let newObj = { 0: {}, 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {} };
      items.forEach((item) => {
        const day = getDayOfWeekFromDate(item.eventDateTime);
        newObj[day][item.id] = item;
      });
      return { ...state, [truckId]: { ...state[truckId], [week]: { ...newObj } } };

    case "CREATE_ITEM":
      if (!state[truckId]) {
        state[truckId] = {};
      }
      if (!state[truckId][week]) {
        state[truckId][week] = {};
      }
      if (!state[truckId][week][day]) {
        state[truckId][week][day] = {};
      }

      return {
        ...state,
        [truckId]: {
          ...state[truckId],
          [week]: {
            ...state[truckId][week],
            [day]: {
              [itemId]: {
                ...itemData,
                approvalState: getApprovalState(roleId, action.type, itemData.approvalState, "linehaulFloating"),
                userAdded: true,
              },
              ...state[truckId][week][day],
            },
          },
        },
      };

    case "UPDATE_ITEM":
      // example call: diapatch({type: "UPDATE_ITEM", truckId, week, day, itemId, itemData)
      return {
        ...state,
        [truckId]: {
          ...state[truckId],
          [week]: {
            ...state[truckId][week],
            [day]: {
              ...state[truckId][week][day],
              [itemId]: {
                ...state[truckId][week][day][itemId],
                ...itemData,
                approvalState: getApprovalState(roleId, action.type, itemData.approvalState, "linehaulFloating"),
                // state[truckId][week][day][itemId].approvalState === statuses.added ? statuses.added : statuses.changed
              },
            },
          },
        },
      };

    case "DELETE_ITEM":
      return {
        ...state,
        [truckId]: {
          ...state[truckId],
          [week]: {
            ...state[truckId][week],
            [day]: {
              ...state[truckId][week][day],
              [itemId]: {
                ...state[truckId][week][day][itemId],
                approvalState: getApprovalState(roleId, action.type, itemData.approvalState, "linehaulFloating"),
              },
            },
          },
        },
      };

    case "APPROVE_ITEM":
      return {
        ...state,
        [truckId]: {
          ...state[truckId],
          [week]: {
            ...state[truckId][week],
            [day]: {
              ...state[truckId][week][day],
              [itemId]: {
                ...state[truckId][week][day][itemId],
                approvalState: getApprovalState(roleId, action.type, itemData.approvalState, "linehaulFloating"),
              },
            },
          },
        },
      };

    default:
      console.error("reducer default clause");
      return state;
  }
};
